// Benign browser warning when ResizeObserver callbacks affect layout in the same frame.
// CRA's dev overlay treats it as a fatal error; suppress so it does not block development.
const RESIZE_OBSERVER_LOOP =
  /^ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;

window.addEventListener(
  'error',
  (event) => {
    if (event?.message && RESIZE_OBSERVER_LOOP.test(event.message)) {
      event.stopImmediatePropagation();
    }
  },
  true
);
